import { useEffect, useState } from 'react';
import TabularDataStepOne from './TabularDataStepOne';
import TabularDataStepTwo from './TabularDataStepTwo';
import { useAppState } from 'components/contexts/State';
import {
  getEditStepOneData,
  getEditStepTwoTableData,
  getSelectSources,
  getStepOneDetailsNotification,
  getTableData,
  getTabularData,
  postStepOneData,
  postStepTwoData,
  putEditStepOneData,
  putEditStepTwoData,
} from '../Services/DataRepoService';

function TabularDataSteps() {
  const {
    openTabularStepOneDialog,
    setOpenTabularStepOneDialog,
    openTabularStepTwoDialog,
    setOpenTabularStepTwoDialog,
    currProcessId,
    uploadStatusDetails,
    setUploadStatusDetails,
    setTabularStepTwoResponse,
    setDisabledUploadDataBtn,
    setTabularData,
    editRowId,
    setIsToasterMessageOpen,
    setToasterMessage,
    setToasterType,
  } = useAppState();

  const [stepTwoTableData, setStepTwoTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editGetResponse, setEditGetResponse] = useState({});
  const userData = JSON.parse(localStorage.getItem('user')) || null;
  const handleNextStepParent = async (form) => {
    if (openTabularStepOneDialog.value && openTabularStepOneDialog.isFromNotification) {
      await handleNotificationNextStep(form);
    } else {
      await handleEditNextStep(form);
    }
  };

  const handleNotificationNextStep = async (form) => {
    setIsLoading(true);
    try {
      if (form) {
        const dataToSend = form;
        if (dataToSend.data_refresh_date === '') {
          delete dataToSend.data_refresh_date;
        }

        const response = await postStepOneModalData(dataToSend);
        if (response && response?.table_name) {
          await getStepTwoTableData(response?.table_name);
          setOpenTabularStepOneDialog({
            value: false,
            isFromNotification: true,
          });
          setOpenTabularStepTwoDialog(true);
          const tempUploadStatus = [];
          uploadStatusDetails.forEach((ele) => {
            if (ele.step === 'Add details') ele.status = 'In progress';
            tempUploadStatus.push(ele);
          });
          setUploadStatusDetails(tempUploadStatus);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setOpenTabularStepOneDialog({
        value: false,
        isFromNotification: true,
      });
      setIsLoading(false);
    }
  };

  const getStepTwoTableData = async (data) => {
    try {
      const tableData = await getTableData(data);

      if (tableData && tableData?.table_data?.length > 0) setStepTwoTableData(tableData);
    } catch (error) {
      console.error(error.message);
    } finally {
    }
  };

  const handleCloseStep2 = () => {
    if (!isLoading) {
      setOpenTabularStepTwoDialog(false);
      setStepTwoTableData([]);
    }
  };

  const postStepOneModalData = async (formDataa) => {
    try {
      let dataToPost = { ...formDataa };
      if (typeof dataToPost?.source_id === 'number') {
        delete dataToPost.source_name;
      } else if (dataToPost?.source_id === 'add-new-source') {
        dataToPost.source_id = null;
      }
      dataToPost.process_id = currProcessId;

      const response = await postStepOneData(dataToPost);

      return response;
    } catch (error) {
      console.error(error.message);
    }
  };

  //handle step two save modal
  const stepTwoSaveParent = async (tableData) => {
    if (openTabularStepOneDialog.isFromNotification) {
      await handleStepTwoDataSave(tableData);
    } else {
      let data = { ...tableData };
      delete data.process_id;

      await handleEditStepTwoDataSave(data);
    }
  };

  const handleStepTwoDataSave = async (tableData) => {
    let tempUploadStatus = [];
    uploadStatusDetails.forEach((ele) => {
      if (ele.step === 'Add details') ele.status = 'Completed';
      if (ele.step === 'Finalize') ele.status = 'In progress';
      tempUploadStatus.push(ele);
    });
    setUploadStatusDetails(tempUploadStatus);
    handleCloseStep2();
    try {
      const res = await postStepTwoData(tableData);
      if (res) setTabularStepTwoResponse(res);
      tempUploadStatus = [];
      uploadStatusDetails.forEach((ele) => {
        if (ele.step === 'Add details') ele.status = 'Completed';
        if (ele.step === 'Finalize') ele.status = 'Completed';
        tempUploadStatus.push(ele);
      });
      setUploadStatusDetails(tempUploadStatus);
    } catch (error) {
      console.error(error.message);
      tempUploadStatus = [];
      uploadStatusDetails.forEach((ele) => {
        if (ele.step === 'Add details') ele.status = 'Completed';
        if (ele.step === 'Finalize') {
          ele.status = 'Error';
          ele.message = error.message;
        }
        tempUploadStatus.push(ele);
      });
      setUploadStatusDetails(tempUploadStatus);
    } finally {
      setDisabledUploadDataBtn(false);
    }
  };

  const [programList, setProgramList] = useState([]);

  useEffect(() => {
    if (openTabularStepOneDialog.value) {
      const fetchOptions = async () => {
        try {
          const response = await getSelectSources();
          setProgramList(response);
        } catch (error) {
          console.error(error.message);
        }
      };
      fetchOptions();
    }
  }, [openTabularStepOneDialog.value]);

  const [saveStepOnePreviousSessionData, setSaveStepOnePreviousSessionData] = useState(
    {}
  );

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    return dateString.split('T')[0];
  };

  //edit functions
  useEffect(() => {
    const handleGetStepOneData = async () => {
      try {
        const res = await getStepOneDetailsNotification(currProcessId);
        if (res) {
          const extractedData = {
            data_creation_date: formatDateForInput(res.data_creation_date),
            table_description: res.table_description,
            source_id: res.source_id,
            data_refresh_date: formatDateForInput(res.data_refresh_date),
          };

          setSaveStepOnePreviousSessionData({
            ...extractedData,
            source_id:
              extractedData.source_id === null
                ? 'add-new-source'
                : extractedData.source_id,
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    const handleEditData = async () => {
      try {
        const res = await getEditStepOneData(editRowId);

        if (res) {
          setEditGetResponse(res);
          const extractedData = {
            data_creation_date: formatDateForInput(res.data_creation_date),
            table_description: res.table_description,
            source_id: res.source_id,
            data_refresh_date: formatDateForInput(res.data_refresh_date),
          };

          setSaveStepOnePreviousSessionData({
            ...extractedData,
            source_id:
              extractedData.source_id === null
                ? 'add-new-source'
                : extractedData.source_id,
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (
      openTabularStepOneDialog.value &&
      openTabularStepOneDialog.isFromNotification &&
      currProcessId &&
      uploadStatusDetails &&
      uploadStatusDetails.length > 0 &&
      uploadStatusDetails[1].step === 'Add details' &&
      uploadStatusDetails[1].status === 'In progress'
    ) {
      handleGetStepOneData();
    } else if (
      openTabularStepOneDialog.value &&
      !openTabularStepOneDialog.isFromNotification
    ) {
      handleEditData();
    }
  }, [
    currProcessId,
    uploadStatusDetails,
    openTabularStepOneDialog.value,
    openTabularStepOneDialog.isFromNotification,
  ]);

  const handleEditNextStep = async (formData) => {
    setIsLoading(true);
    try {
      if (formData) {
        const dataToSend = formData;
        if (dataToSend.data_refresh_date === '') {
          delete dataToSend.data_refresh_date;
        }
        const res = await putEditStepOneModalData(dataToSend);
        if (res) {
          await getEditStepTwoColumnData(
            editGetResponse.table_name,
            editGetResponse.dataset_name
          );
          setOpenTabularStepOneDialog({
            value: false,
            isFromNotification: false,
          });
          setOpenTabularStepTwoDialog(true);
        }
      }
    } catch (error) {
      console.error(error);
      if (error.status === 403) {
        setIsToasterMessageOpen(true);
        setToasterMessage(error.message);
        setToasterType('warning');
      }
    } finally {
      setOpenTabularStepOneDialog({
        value: false,
        isFromNotification: false,
      });
      setIsLoading(false);
    }
  };

  const putEditStepOneModalData = async (formData) => {
    try {
      let dataToPost = { ...formData };
      if (typeof dataToPost?.source_id === 'number') {
        delete dataToPost.source_name;
      } else if (dataToPost?.source_id === 'add-new-source') {
        dataToPost.source_id = null;
      }
      const response = await putEditStepOneData(editRowId, dataToPost);

      return response;
    } catch (error) {
      console.error(error.message);
      if (error.status === 403) {
        setIsToasterMessageOpen(true);
        setToasterMessage(error.message);
        setToasterType('warning');
      }
    }
  };

  const getEditStepTwoColumnData = async (tableNm, dataSetNm) => {
    try {
      const tableData = await getEditStepTwoTableData(tableNm, dataSetNm);

      if (tableData && tableData?.table_data?.length > 0) setStepTwoTableData(tableData);
    } catch (error) {
      console.error(error.message);
    } finally {
    }
  };

  const handleFetchTabularData = async () => {
    try {
      const response = await getTabularData(userData?.email);
      if (response && response.length > 0) {
        setTabularData(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleEditStepTwoDataSave = async (tableData) => {
    setIsLoading(true);
    try {
      const res = await putEditStepTwoData(editRowId, tableData);
      if (res) {
        await handleFetchTabularData();
      }
    } catch (error) {
      console.error(error.message);
      if (error.status === 403) {
        setIsToasterMessageOpen(true);
        setToasterMessage(error.message);
        setToasterType('warning');
      }
    } finally {
      setIsLoading(false);
      handleCloseStep2();
    }
  };

  return (
    <>
      <TabularDataStepOne
        open={openTabularStepOneDialog.value}
        isFromNotification={openTabularStepOneDialog.isFromNotification}
        onClose={() =>
          setOpenTabularStepOneDialog({
            value: false,
            isFromNotification: openTabularStepOneDialog.isFromNotification,
          })
        }
        onNext={handleNextStepParent}
        isLoading={isLoading}
        programList={programList}
        initialGetData={saveStepOnePreviousSessionData}
      />
      <TabularDataStepTwo
        open={openTabularStepTwoDialog}
        onClose={handleCloseStep2}
        data={stepTwoTableData}
        isLoading={isLoading}
        onSave={stepTwoSaveParent}
      />
    </>
  );
}

export default TabularDataSteps;
